export const styles = {
  global: {
    body: {
      bg: 'var(--chakra-colors-background-global-light)',
      font: 'var(--nabis-font-body)',
      minWidth: '0px',
    },
  },
};
